import { useDebugValue } from 'react';
import { isNull } from 'utils/tsHelpers';
import { ElementType, useIndex } from '../../../contexts/elementIndex';

export const useIsFirstCondition = () => {
  const index = useIndex(ElementType.condition);
  if (isNull(index)) {
    throw new Error('Could not determine if condition is first: no condition index in context');
  }
  const isFirstCondition = index === 0;
  useDebugValue(isFirstCondition);
  return isFirstCondition;
};
